import React from 'react';
import { useI18n } from '../../../contexts/I18nContext';
import AiToolTemplateV2 from '../../AiToolTemplate/AiToolTemplateV2';
import {
  createComponentConfig,
  createComponentItem,
  COMPONENT_TYPES,
  PROMPT_STRATEGIES,
  TOOL_IDS
} from '../../AiToolTemplate/config/componentConfig';

const EmojiPack = () => {
  const { t } = useI18n();

  const emojiPackConfig = createComponentConfig({
    components: [
      createComponentItem({
        type: COMPONENT_TYPES.IMAGE_UPLOAD,
        id: 'sourceImage',
        title: t('aiToolTemplate.uploadImage'),
        description: t('aiToolTemplate.uploadImageDescription'),
        required: true,
        props: {
          acceptedFormats: ['jpg', 'jpeg', 'png', 'gif', 'webp'],
          maxSize: 10 * 1024 * 1024,
          preview: true,
          multiple: false,
          placeholder: t('aiToolTemplate.clickOrDragUpload')
        },
        order: 1
      }),
      createComponentItem({
        id: 'size',
        type: COMPONENT_TYPES.SIZE_SELECTOR,
        title: t('aiWorkbench.size'),
        required: true,
        defaultValue: 'Auto',
        order: 2
      }),
      createComponentItem({
        type: COMPONENT_TYPES.PROMPT_INPUT,
        id: 'supplementaryPrompt',
        title: t('aiToolTemplate.supplementaryPrompt'),
        description: t('aiToolTemplate.supplementaryPromptDescription'),
        required: false,
        props: {
          placeholder: t('aiToolTemplate.enterSupplementaryPrompt')
        },
        order: 3
      })
    ],
    promptConfig: {
      strategy: PROMPT_STRATEGIES.CUSTOM,
      customHandler: (values) => {
        return values.supplementaryPrompt;
      }
    },
    additionalParams: {
      model: 'nano',
      width: 512,
      height: 512,
      style: 'emoji-pack'
    }
  });

  return (
    <AiToolTemplateV2
      toolName={t('aiToolTemplate.tools.emojiPack.name')}
      toolIcon="😄"
      toolDescription={t('aiToolTemplate.tools.emojiPack.description')}
      config={emojiPackConfig}
      gradientColors={['#FF9A9E', '#FECFEF']}
      toolId={TOOL_IDS.EMOJI_PACK}
    />
  );
};

export default EmojiPack;

